var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-content",domProps:{"innerHTML":_vm._s(_vm.sanitized_content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }